function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var _jsxFileName = "/Users/vincent.limshowchen/Sites/account-components/src/components/ManageFollowRow/index.js";
var _excluded = ["dataAttr", "handlers"],
  _excluded2 = ["dataAttr", "handlers"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { SpotType } from "@mlb/react-patterns/dist/components/Spot/spot.types";
import SpotTag from "@mlb/react-patterns/dist/components/SpotTag/spotTag";
import { motion } from "framer-motion";
import React from "react";
import { ManageFollowRowContainer, ManageFollowRowDeleteButton, ManageFollowRowDragHandle, ManageFollowRowInnerContainer, ManageFollowRowRemoveButton, ManageFollowRowRemoveContainer, REMOVE_BUTTON_WIDTH } from "./styles";
var ComponentKey = "manage-follow-row";
var DeleteButtonTestId = "".concat(ComponentKey, "__delete-button");
var RemoveButtonTestId = "".concat(ComponentKey, "__remove-button");
var Noop = function Noop() {};
var ManageFollowRow = function ManageFollowRow(_ref) {
  var alt = _ref.alt,
    className = _ref.className,
    containerProps = _ref.containerProps,
    deleteButtonProps = _ref.deleteButtonProps,
    _ref$deleteLabel = _ref.deleteLabel,
    deleteLabel = _ref$deleteLabel === void 0 ? "Delete follow" : _ref$deleteLabel,
    dragHandleProps = _ref.dragHandleProps,
    id = _ref.id,
    isFavorite = _ref.isFavorite,
    _ref$lazyload = _ref.lazyload,
    lazyload = _ref$lazyload === void 0 ? false : _ref$lazyload,
    name = _ref.name,
    _ref$onDeleteClick = _ref.onDeleteClick,
    onDeleteClick = _ref$onDeleteClick === void 0 ? Noop : _ref$onDeleteClick,
    _ref$onDragHandlePoin = _ref.onDragHandlePointerDown,
    onDragHandlePointerDown = _ref$onDragHandlePoin === void 0 ? Noop : _ref$onDragHandlePoin,
    _ref$onDragHandlePoin2 = _ref.onDragHandlePointerUp,
    onDragHandlePointerUp = _ref$onDragHandlePoin2 === void 0 ? Noop : _ref$onDragHandlePoin2,
    _ref$onRemoveClick = _ref.onRemoveClick,
    onRemoveClick = _ref$onRemoveClick === void 0 ? Noop : _ref$onRemoveClick,
    removeButtonProps = _ref.removeButtonProps,
    _ref$removeLabel = _ref.removeLabel,
    removeLabel = _ref$removeLabel === void 0 ? "Remove" : _ref$removeLabel,
    showDragHandle = _ref.showDragHandle,
    showRemove = _ref.showRemove,
    spotTagProps = _ref.spotTagProps,
    superName = _ref.superName,
    type = _ref.type;
  if (!id || !type) {
    // eslint-disable-next-line
    console.error("❌ [ManageFollowRow] props `id` and `type` are required");
    return null;
  }
  if (isFavorite && type === SpotType.PLAYER) {
    // eslint-disable-next-line
    console.warn("[ManageFollowRow] Invalid Configuration: prop `isFavorite === true` and `type === 'player'`");
  }
  var _ref2 = deleteButtonProps || {},
    deleteButtonDataAttr = _ref2.dataAttr,
    _ref2$handlers = _ref2.handlers,
    deleteButtonHandlers = _ref2$handlers === void 0 ? {} : _ref2$handlers,
    restDeleteButtonProps = _objectWithoutProperties(_ref2, _excluded);
  var _ref3 = removeButtonProps || {},
    removeButtonDataAttr = _ref3.dataAttr,
    _ref3$handlers = _ref3.handlers,
    removeButtonHandlers = _ref3$handlers === void 0 ? {} : _ref3$handlers,
    restRemoveButtonProps = _objectWithoutProperties(_ref3, _excluded2);
  return /*#__PURE__*/React.createElement(ManageFollowRowContainer, _extends({
    as: motion.li,
    className: className,
    "data-testid": "".concat(ComponentKey, "--").concat(id),
    exit: {
      height: 0,
      opacity: 0,
      transition: {
        delay: 0.3
      }
    }
  }, containerProps, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 67,
      columnNumber: 5
    }
  }), /*#__PURE__*/React.createElement(ManageFollowRowInnerContainer, {
    animate: {
      x: showRemove ? "-".concat(REMOVE_BUTTON_WIDTH) : 0
    },
    as: motion.div,
    exit: {
      x: "-100%"
    },
    transition: {
      stiffness: 100
    },
    __source: {
      fileName: _jsxFileName,
      lineNumber: 74,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(ManageFollowRowDeleteButton, _extends({
    ariaLabel: deleteLabel,
    dataAttr: _objectSpread({
      "data-testid": "".concat(DeleteButtonTestId, "--").concat(id)
    }, deleteButtonDataAttr),
    disabled: showRemove,
    handlers: _objectSpread({
      onClick: onDeleteClick
    }, deleteButtonHandlers)
  }, restDeleteButtonProps, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 80,
      columnNumber: 9
    }
  })), /*#__PURE__*/React.createElement(SpotTag, _extends({
    alt: alt,
    id: id,
    isFavorite: isFavorite,
    lazyload: lazyload,
    name: name,
    superName: superName === "Athletics" ? "" : superName,
    type: type
  }, spotTagProps, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 90,
      columnNumber: 9
    }
  })), showDragHandle && /*#__PURE__*/React.createElement(ManageFollowRowDragHandle, _extends({
    containerProps: {
      disabled: showRemove
    },
    onPointerDown: onDragHandlePointerDown,
    onPointerUp: onDragHandlePointerUp
  }, dragHandleProps, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 101,
      columnNumber: 11
    }
  }))), /*#__PURE__*/React.createElement(ManageFollowRowRemoveContainer, {
    showRemove: showRemove,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 111,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(ManageFollowRowRemoveButton, _extends({
    disabled: !showRemove,
    dataAttr: _objectSpread({
      "data-testid": "".concat(RemoveButtonTestId, "--").concat(id)
    }, removeButtonDataAttr),
    handlers: _objectSpread({
      onClick: onRemoveClick
    }, removeButtonHandlers)
  }, restRemoveButtonProps, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 112,
      columnNumber: 9
    }
  }), removeLabel)));
};
export default /*#__PURE__*/React.memo(ManageFollowRow);